import cx from 'classnames';
import Skeleton from '../presentational/skeleton';

export const SkeletonGearSection = () => {
	return (
		<>
			<Skeleton height={42} />
			<Skeleton variant="item" height={169} animate />
		</>
	)
}

export const SkeletonTalentsSection = () => {
	return (
		<>
			<Skeleton height={42} />
			<Skeleton variant="item" height={169} animate />
		</>
	)
}

export default function SkeletonGearAndTalents() {
	return (
		<div
			className="slds-grid slds-grid--vertical-stretch slds-wrap"
			style={{ marginBottom: 24 }}
		>
			<div
				className={cx(
					'slds-size--8-of-12',
					'slds-max-small-size--1-of-1',
					'slds-max-medium-size--1-of-1',
					'slds-p-horizontal--small',
					'slds-m-bottom--x-large',
					'rio-m-bottom-mobi--large'
				)}
			>
				<SkeletonGearSection />
			</div>
			<div
				className={cx(
					'slds-size--4-of-12',
					'slds-max-small-size--1-of-1',
					'slds-max-medium-size--1-of-1',
					'slds-p-horizontal--small',
					'slds-m-bottom--x-large',
					'rio-m-bottom-mobi--large'
				)}
			>
				<SkeletonTalentsSection />
			</div>
		</div>
	)
}
